import { RefObject } from 'react';

type ProgramsListData = {
  programsItemRef: RefObject<HTMLElement>;
  programsItemsNumber: number;
  listBottomPadding: number;
  itemsInRowCount: number;
  programsListGridGap: number;
};

export const getProgramsListHeight = ({
  programsItemRef,
  programsItemsNumber,
  listBottomPadding,
  itemsInRowCount,
  programsListGridGap,
}: ProgramsListData) => {
  if (!programsItemRef.current) return null;

  const programsItemHeight = programsItemRef.current.clientHeight;
  const programsItemBottomMargin = Number.parseInt(
    getComputedStyle(programsItemRef.current).marginBottom,
  );

  const rowHeight =
    programsItemHeight + programsItemBottomMargin + programsListGridGap;

  const rowCount = Math.ceil(programsItemsNumber / itemsInRowCount);

  return rowHeight * rowCount + listBottomPadding;
};
